import { Icon, Typography } from '@mui/material'
import ImageContainer from 'components/atoms/container/ImageContainer'
import { CALENDAR_OAUTH_TOKEN_PROVIDERS } from 'services/constants'

const ConnectedCalendarItem = ({ provider, email }) => {
  return (
    provider &&
    email && (
      <Typography display='flex' alignItems='center' component='div'>
        <Icon sx={{ marginRight: '10px' }}>
          {provider === CALENDAR_OAUTH_TOKEN_PROVIDERS.MICROSOFT ? (
            <ImageContainer
              src='https://cdn-icons-png.flaticon.com/64/5969/5969144.png'
              alt='microsoft'
            />
          ) : (
            <ImageContainer
              src='https://lh3.googleusercontent.com/COxitqgJr1sJnIDe8-jiKhxDx1FrYbtRHKJ9z_hELisAlapwE9LUPh6fcXIfb5vwpbMl4xl9H9TRFPc5NOO8Sb3VSgIBrfRYvW6cUA'
              alt='google'
            />
          )}
        </Icon>
        {email}
      </Typography>
    )
  )
}

export default ConnectedCalendarItem
